/**
 * Convex sends and receives schedule cells as {column, value} lists, since
 * header text can't be a Convex field name. The app keys them by column.
 */
export type ScheduleCell = { column: string; value: string };

export function toCellRecord(cells: ScheduleCell[]): Record<string, string> {
  return Object.fromEntries(cells.map((cell) => [cell.column, cell.value]));
}

export function toCellList(cells: Record<string, string>): ScheduleCell[] {
  return Object.entries(cells).map(([column, value]) => ({ column, value }));
}
